import { UserRound } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { DetailDialog, DetailRow } from "@/components/ui/detail-dialog";
import { fmtRelativeTime } from "@/lib/utils";
import type { User } from "@/lib/api/types";

export function UserDetailDialog({ user, onClose }: { user: User | null; onClose: () => void }) {
  const status = user?.status ?? "ACTIVE";
  const active = status === "ACTIVE";
  return (
    <DetailDialog
      open={user !== null}
      onClose={onClose}
      icon={UserRound}
      title={user?.name || "User"}
      subtitle={user ? `${user.id.slice(0, 8)}…` : undefined}
    >
      {user && (
        <>
          <DetailRow label="Email" value={user.email} />
          <DetailRow label="Phone" value={user.phoneNumber} />
          <DetailRow label="Role" value={<Badge variant={user.role === "ADMIN" ? "sunset" : "muted"}>{user.role}</Badge>} />
          <DetailRow label="Status" value={<Badge variant={active ? "success" : "destructive"}>{status}</Badge>} />
          {user.role === "DOCTOR" && (
            <>
              <DetailRow
                label="Doctor"
                value={<Badge variant={user.doctorVerified ? "success" : "warning"}>{user.doctorVerified ? "Verified" : "Pending"}</Badge>}
              />
              <DetailRow label="Specialization" value={user.specialization} />
              <DetailRow label="Hospital" value={user.hospital} />
            </>
          )}
          {user.bio && <DetailRow label="Bio" value={<span className="line-clamp-4 text-left">{user.bio}</span>} />}
          <DetailRow label="Joined" value={user.createdAt ? fmtRelativeTime(user.createdAt) : "—"} />
          <DetailRow label="User ID" value={<span className="font-mono text-xs">{user.id}</span>} />
        </>
      )}
    </DetailDialog>
  );
}
